var map = {
	"./1.png": 1530,
	"./2.png": 1531,
	"./3.png": 1532,
	"./4.png": 1533,
	"./5.png": 1534,
	"./6.png": 1535,
	"./7.png": 1536,
	"./8.png": 1537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1529;